import {gql} from '@apollo/client'

export const GET_BIRTHDAYS_BY_MONTH = gql`
  query birthdaysByMonth($month: Int!, $day: Int) {
    birthdaysByMonth(month: $month, day: $day) {
      isPartial
      totalCount
      contacts {
        id
        firstName
        middleName
        lastName
        secondLastName
        dateBirth
        phone
        user {
          id
          firstName
          lastName
          npn
        }
        memberPolicy {
          policy {
            user {
              id
              firstName
              lastName
              npn
            }
          }
        }
      }
    }
  }
`
